import React from "react";
import "./index.scss";
import Menu from "../../menu/carousel_data.json";
import { graphql, useStaticQuery } from "gatsby";
import { useTranslation } from "react-i18next";
import Carousel from "../Carousel";
const Landing = ({ lang }) => {
  let { carousel = [] } = Menu || {};
  const { t } = useTranslation();
  const result = useStaticQuery(
    graphql`
      query {
        allImageSharp(
          filter: {
            fluid: {
              originalName: {
                in: [
                  "caesar.png"
                  "salmon.png"
                  "blt.png"
                  "caesar_motion.png"
                  "salmon_motion.png"
                  "blt_motion.png"
                ]
              }
            }
          }
        ) {
          nodes {
            fluid(maxHeight: 600) {
              originalName
              ...GatsbyImageSharpFluid
            }
          }
        }
      }
    `
  );
  let { allImageSharp = {} } = result || {},
    { nodes = [] } = allImageSharp;
  let images = {};
  nodes.forEach((node) => {
    let { fluid = {} } = node || {},
      { originalName } = fluid;
    images[originalName] = fluid;
  });
  return (
    <div className="landing" id="landing">
      <div className="claim-text desktop:desktop-h1 mobile:mobile-h1 tablet:mobile-h1">
        {t("claimPart1")}
        <span className="green">{t("claimPart2")}</span>
        {t("claimPart3")}
        <span>{t("claimPart4")}</span>
      </div>
      <Carousel slides={carousel} lang={lang} images={images} />
      <div className="divider layout desktop:container-desktop mobile:container-mobile tablet:container-mobile"></div>
    </div>
  );
};

export default Landing;
